import { useCallback, useEffect, useState } from "react";

import {
  clearWatchlistStorage,
  normalizeWatchlistIds,
  readWatchlistIdsFromStorage,
  writeWatchlistIdsToStorage,
} from "~/feature/watchlist/utils/storage";

export const useGuestWatchlistStorage = () => {
  const [ids, setIdsState] = useState<string[]>([]);

  useEffect(() => {
    setIdsState(readWatchlistIdsFromStorage());
  }, []);

  const setIds = useCallback((next: string[]) => {
    const normalized = normalizeWatchlistIds(next);
    setIdsState(normalized);
    writeWatchlistIdsToStorage(normalized);
  }, []);

  const clear = useCallback(() => {
    setIdsState([]);
    clearWatchlistStorage();
  }, []);

  return { ids, setIds, clear };
};
